import { render, staticRenderFns } from "./projectList.vue?vue&type=template&id=4ad07fdd"
import script from "./projectList.vue?vue&type=script&lang=js"
export * from "./projectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ad07fdd')) {
      api.createRecord('4ad07fdd', component.options)
    } else {
      api.reload('4ad07fdd', component.options)
    }
    module.hot.accept("./projectList.vue?vue&type=template&id=4ad07fdd", function () {
      api.rerender('4ad07fdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/grade/projectList.vue"
export default component.exports